/**
 * @generated SignedSource<<6e9139016505e88b1a1e34dfa2824f16>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ViewsDropdown_user$data = {
  readonly id: number;
  readonly " $fragmentSpreads": FragmentRefs<"ViewFormDialog_user">;
  readonly " $fragmentType": "ViewsDropdown_user";
};
export type ViewsDropdown_user$key = {
  readonly " $data"?: ViewsDropdown_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"ViewsDropdown_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "peopleFilter"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectsFilter"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ViewsDropdown_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "peopleFilter",
          "variableName": "peopleFilter"
        },
        {
          "kind": "Variable",
          "name": "projectsFilter",
          "variableName": "projectsFilter"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ViewFormDialog_user"
    }
  ],
  "type": "users",
  "abstractKey": null
};

(node as any).hash = "13f836cc72685ad51043981668c9edeb";

export default node;
